/**
 * 쿠키 유틸리티 함수들
 */

/**
 * 쿠키 설정
 * @param {string} name - 쿠키 이름
 * @param {string} value - 쿠키 값
 * @param {number} days - 만료일 (일 단위)
 */
export function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

/**
 * 쿠키 가져오기
 * @param {string} name - 쿠키 이름
 * @returns {string|null} 쿠키 값 또는 null
 */
export function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/**
 * 쿠키 삭제
 * @param {string} name - 쿠키 이름
 */
export function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

/**
 * MallManagerInfo 모달 숨김 쿠키 키 생성
 * @param {string} shopNo - 상점 번호
 * @param {string} mallId - 몰 ID
 * @param {string} appCode - 앱 코드
 * @returns {string} 쿠키 키
 */
export function getMallManagerInfoCookieKey(shopNo, mallId, appCode) {
  return `hide_mall_manager_info_${shopNo}_${mallId}_${appCode}`;
}

/**
 * MallManagerInfo 모달 숨김 상태 확인
 * @param {string} shopNo - 상점 번호
 * @param {string} mallId - 몰 ID
 * @param {string} appCode - 앱 코드
 * @returns {boolean} 숨김 상태 여부 (true: 숨김, false: 표시)
 */
export function shouldHideMallManagerInfo(shopNo, mallId, appCode) {
  const cookieKey = getMallManagerInfoCookieKey(shopNo, mallId, appCode);
  const cookieValue = getCookie(cookieKey);

  if (!cookieValue) {
    return false; // 쿠키가 없으면 모달 표시
  }

  try {
    const hideUntil = new Date(cookieValue);
    const now = new Date();
    return now < hideUntil; // 현재 시간이 숨김 기간 이전이면 숨김
  } catch (e) {
    // 쿠키 값이 잘못된 경우 쿠키 삭제 후 모달 표시
    deleteCookie(cookieKey);
    return false;
  }
}

/**
 * MallManagerInfo 모달 15일 숨김 쿠키 설정
 * @param {string} shopNo - 상점 번호
 * @param {string} mallId - 몰 ID
 * @param {string} appCode - 앱 코드
 */
export function setMallManagerInfoHideCookie(shopNo, mallId, appCode) {
  const cookieKey = getMallManagerInfoCookieKey(shopNo, mallId, appCode);
  const hideUntil = new Date();
  hideUntil.setDate(hideUntil.getDate() + 15); // 15일 후

  setCookie(cookieKey, hideUntil.toISOString(), 15);
}
